import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import NotFoundPage from './NotFoundPage';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Route wrapper that checks for admin_view permission.
 * Shows NotFoundPage if user doesn't have permission (instead of redirecting).
 */
const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { hasFeature, isLoading } = usePermissions();
  const hasAdminAccess = hasFeature('admin_view');

  // Show loading state while checking permissions
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  // Show NotFoundPage if user doesn't have admin access
  if (!hasAdminAccess) {
    return <NotFoundPage />;
  }

  return <>{children}</>;
};

export default AdminProtectedRoute;
